<template>
	<vs-navbar :type="'border'" v-model="activeItem" class="nabarx" style="background-color: white">
		<div slot="title">
			<vs-navbar-title>
				<span>{{ toolBarTitle }}</span>
			</vs-navbar-title>
		</div>

		<vs-navbar-item index="0">
			<a href="#" class="text-center" @click="selectTool('circle')"
				><feather-icon class="cursor-pointer" icon="CircleIcon" /><br /><small>{{
					$t("DrawingTools.Circle")
				}}</small></a
			>
		</vs-navbar-item>
		<vs-navbar-item index="1">
			<a href="#" @click="selectTool('polygon')" class="text-center"
				><feather-icon class="cursor-pointer" icon="HexagonIcon" /><br /><small>{{
					$t("DrawingTools.Polygon")
				}}</small></a
			>
		</vs-navbar-item>
		<vs-navbar-item index="2">
			<a href="#" @click="selectTool(null)" class="text-center"
				><feather-icon class="cursor-pointer" icon="MousePointerIcon" /><br /><small>{{
					$t("DrawingTools.Selection")
				}}</small></a
			>
		</vs-navbar-item>

		<vs-navbar-item index="3" v-if="showBtnDeleteShape">
			<a href="#" class="text-center" @click="deleteShape"
				><feather-icon class="cursor-pointer" icon="XSquareIcon" /><br /><small>{{ $t("Remove") }}</small></a
			>
		</vs-navbar-item>
		<vs-navbar-item index="4" v-if="showBtnCleanSelection">
			<a href="#" class="text-center" @click="clearMapEmit"
				><feather-icon class="cursor-pointer" icon="Trash2Icon" /><br /><small>{{
					$t("RemoveSelection")
				}}</small></a
			>
		</vs-navbar-item>
	</vs-navbar>
</template>

<script>
export default {
	props: {
		toolBarTitle: {
			type: String,
			default: () => "",
		},
		mode: {
			type: Number,
			default: () => 0,
		},
		idCapa: {
			type: Number,
			default: () => 0,
		},
		selectedLayer: null,
		showSaveBtnEquivalents: {
			type: Boolean,
			default: () => false,
		},
		showSelectionsTools: {
			type: Boolean,
			default: () => false,
		},
		dataRutasEnabled: {
			type: Boolean,
			default: () => false,
		},
		showBtnDeleteShape: {
			type: Boolean,
			default: () => false,
		},
		showBtnCleanSelection: {
			type: Boolean,
			default: () => false,
		},
	},
	data() {
		return {
			shapeColor: "#3EC9D6",
			activeItem: "0",
		};
	},
	methods: {
		selectTool(opc) {
			Anuket.selectTool(opc);
		},
		deleteShape() {
			this.$emit("deleteShapeEmit");
		},
		changeColor(fillColor) {
			this.$emit("changeColorEmit", fillColor);
		},
		clearMapEmit() {
			this.$emit("clearMapEmit");
		},
	},
	computed: {
		activeRectangle() {
			return false;
		},
		activePolygon() {
			return this.mode === 1 && this.selectedLayer !== null;
		},
		activePolyline() {
			return this.mode === 8;
		},
		activeMarker() {
			return this.mode === 8;
		},
		activeRemove() {
			return (this.mode === 1 && this.idCapa > 0) || this.mode === 0;
		},
		activeSelection() {
			if (this.mode === 1) return true;
			else if (this.mode === 0) return true;
			else return false;
		},
		activeFillColor() {
			return false;
		},
		activeEditInfo() {
			return this.mode === 1 && this.selectedZone.cartodb_id > 0;
		},
		activeSettingsCapa() {
			return this.mode === 1;
		},
		activeSettingsCapaOptions() {
			return this.mode === 1 && this.selectedLayer !== null;
		},
	},
};
</script>
